import React, { useEffect } from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FAQ } from '../components/FAQ';
import { SITE } from '../data/site';

const setMeta = (name, content, attr = 'name') => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

export default function FAQPage() {
  useEffect(() => {
    document.title = 'FAQ | Gutter Cleaning & Roofline Questions | Leamington Gutters';
    setMeta(
      'description',
      'Answers to the most common questions about gutter cleaning, moss removal, fascia and soffit work in Leamington Spa, Warwick and Kenilworth. Independent, insured and guaranteed.',
    );
    setCanonical('https://leamingtongutters.uk/faq');
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 sm:pt-40 sm:pb-24 bg-[#050505] border-b border-[#E8B842]/10">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="font-display uppercase tracking-[0.4em] text-xs text-[#E8B842]">
              / Help &amp; advice
            </span>
            <h1 className="font-display uppercase font-extrabold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mt-4">
              Frequently Asked <span className="text-[#E8B842]">Questions</span>
            </h1>
            <p className="mt-6 text-[#A3A3A3] text-lg max-w-2xl leading-relaxed">
              A quick guide to gutter cleaning, moss removal, fascia &amp; soffit replacement
              and roofline repair for homeowners in Leamington Spa, Warwick, Kenilworth and the
              surrounding villages.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={SITE.phoneTel}
                data-testid="faq-cta-call"
                className="inline-flex items-center justify-center gap-2 bg-[#E8B842] hover:bg-[#F4C534] text-black font-display font-bold uppercase tracking-wider px-7 py-3.5 transition-colors"
              >
                <Phone className="w-4 h-4" />
                Call Luke — {SITE.phoneDisplay}
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center gap-2 border border-[#E8B842]/40 text-[#E8B842] hover:bg-[#E8B842]/10 font-display font-bold uppercase tracking-wider px-7 py-3.5 transition-colors"
              >
                Get a Free Quote
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </section>

        <FAQ variant="full" />
      </main>
      <Footer />
    </>
  );
}
